{
    "ai_modal_title_1": "Улучшить текст с помощью ИИ",
    "ai_modal_title_2": "Создать текст с помощью ИИ",
    "ai_description": "Используйте инструменты ИИ, чтобы преобразить ваши тексты.",
    "ai_learn_more": "Узнать больше",
    "ai_copy_text": "Копировать текст",
    "ai_describe_your_text": "Опишите о чем должен быть ваш текст",
    "ai_describe_your_text_example": "Например, небольшое описание для магазина крафтового мыла...",
    "ai_new_request": "Создать новый запрос",
    "ai_create_text": "Создать текст",
    "ai_apply_text": "Применить текст",
    "ai_try_one_more": "Попробовать еще раз",
    "ai_correct_errors": "Исправить ошибки",
    "ai_make_longer": "Сделать длиннее",
    "ai_make_shorter": "Укоротить",
    "ai_simplify": "Упростить",
    "ai_business_tone": "Деловой",
    "ai_ceremonial_tone": "Торжественный",
    "ai_fun_tone": "Веселый",
    "ai_friendly_tone": "Дружеский",
    "ai_change_tone": "Изменить тон",
    "ai_improve_text": "Улучшить текст",
    "ai_words_number": "Количество слов:",
    "ai_translate": "Перевести",
    "ai_translate_to_ru": "Перевести на русский",
    "ai_translate_to_en": "Перевести на английский",
    "ai_add_creativity": "Добавить креатива",
    "ai_text_too_large": "Ваш текст слишком длинный для использования ИИ. Сократите его или создайте новый текст нужной тематики с помощью ИИ.",
    "ai_translate_to_ua": "Перевести на украинский",
    "ai_translate_to_es": "Перевести на испанский",
    "ai_translate_to_pt": "Перевести на португальский",
    "ai_translate_to_tr": "Перевести на турецкий",
    "ai_translate_to_fr": "Перевести на французский",
    "ai_translate_to_de": "Перевести на немецкий",
    "ai_translate_to_it": "Перевести на итальянский",
    "ai_translate_to_pl": "Перевести на польский",
    "ai_free_request_error": "Бесплатные запросы закончились",
    "ai_free_request_number": "Количество запросов: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Вы можете использовать 200 бесплатных запросов к инструментам ИИ. Чтобы создать больше запросов, активируйте свой API-ключ сервиса ИИ в настройках вашего аккаунта.",
    "cancel": "Отмена",
    "gpt_error_quota": "Вы израсходовали доступное количество запросов к API. Чтобы использовать инструменты ИИ и дальше, проверьте текущий лимит или пополните баланс в настройках учетной записи OpenAI.",
    "ai_generated_disclaimer": "Ответственность за сгенерированный текст несете вы. Проверьте его перед публикацией."
}
